/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import appRoutes from "../../../routes/appRoutes";
import OpenAppointmentView from "../../../containers/OpenAppointmentView";

class ViewAppointmentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: this.props.location.state.from
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  };

  ticketEditSubmit = formValues => {
    this.setState({ form1Filled: true, form2Active: true });
  };

  render() {
    return (
      <div className="row rounded p-3 view-appointment-page">
        <div className="col-sm-6 p-3">
          <NavLink
            to={
              this.state.from
                ? appRoutes.openAppointments
                : appRoutes.myAppointments
            }
            className="insta-link-orange font-15 text-decoration-none"
            href="/"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 pt-1 back-btn-text">
              {this.state.from
                ? "Back to Open Appointments"
                : "Back to My Appointments"}
            </span>
          </NavLink>
        </div>
        <div className="col-sm-12">
          <OpenAppointmentView backNav={this.state.from} />
        </div>
      </div>
    );
  }
}

export default ViewAppointmentPage;
